import React from 'react'
import { InteractionContext } from '@context/interaction-context/interactionContext'
import { WidgetHOC, WidgetProps } from './WidgetHOC'

const InsuranceStatusContainer = React.lazy(() =>
  import('@features/insurance-status/InsuranceStatus').then(m => ({ default: m.InsuranceStatus }))
)

export const StatusWidget: React.FC<WidgetProps> = props => {
  const { widgetContext } = props

  return (
    <WidgetHOC widgetContext={widgetContext}>
      <InteractionContext.Provider value={{ name: 'insurance-status', type: 'action' }}>
        <InsuranceStatusContainer />
      </InteractionContext.Provider>
    </WidgetHOC>
  )
}
